import { TableCell, TableRow } from '@mui/material';
import React from 'react';
import { CurrentUser, AssociatedTeamMember, DataRoomUser, DataRoom, UnlockUser } from '../../../shared/models';
import { TeamMemberActionButton } from './TeamMemberActionButton';
import { DateUtils } from '../../../shared/utils';

interface TeamMemberRowItemProps {
	dataRoomGuid: string | undefined;
	dataRoom: DataRoom;
	user: DataRoomUser;
	member: AssociatedTeamMember;
	currentUser: CurrentUser;
	unlockUser: (user: UnlockUser) => void;
	accessLogs: (user: UnlockUser) => void;
	removeTeamMember: (member: AssociatedTeamMember) => void;
	sendInvite: (member: UnlockUser) => void;
	contactDetails: (user: AssociatedTeamMember) => void;
}

export const TeamMemberRowItem: React.FC<TeamMemberRowItemProps> = ({
	dataRoomGuid,
	dataRoom,
	user,
	member,
	currentUser,
	unlockUser,
	accessLogs,
	removeTeamMember,
	sendInvite,
	contactDetails,
}) => {
	return (
		<TableRow>
			<TableCell>
				{member.firstName} {member.lastName}
			</TableCell>
			<TableCell>{member.emailAddress}</TableCell>
			<TableCell>
				{member.lastAccessedOn && (
					<>Last accessed: {DateUtils.FormatStringAsShortDate(member.lastAccessedOn.toString())}</>
				)}
				{!member.lastAccessedOn && <>Never accessed</>}
			</TableCell>
			<TableCell>
				<TeamMemberActionButton
					isEmployee={currentUser.isEmployeeUser}
					isBorrower={currentUser.isCompanyUser}
					isBanker={currentUser.isBankUser}
					user={user}
					dataRoom={dataRoom}
					member={member}
					unlockUser={unlockUser}
					accessLogs={accessLogs}
					removeTeamMember={removeTeamMember}
					sendInvite={sendInvite}
					contactDetails={contactDetails}
				/>
			</TableCell>
		</TableRow>
	);
};
